import { CheckCircleOutlined, CloseCircleOutlined, EyeOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Space, Table, Tag, Tooltip, Typography } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { rightsService } from '../../../services/rightsService';
import { LOGGED_USER } from '../../../variables/constants';

// Couleurs de la charte
const PRIMARY_COLOR = '#242166';
const SUCCESS_COLOR = '#52c41a';
const ERROR_COLOR = '#ff4d4f';

const { Text } = Typography;
const UtilisateursAgenceTab = ({ utilisateurs }) => {
    const navigate = useNavigate();
    const isAdminProfile = (LOGGED_USER?.profil?.nom || "").toLowerCase().includes("admin");
    const canAddUser = rightsService("HPE038") || rightsService("HPE033") || isAdminProfile;

    const columns = [
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: 450,
            render: (text, record) => (
                <Tooltip onClick={() => navigate(`/details-utilisateur/${record.codeId}`)} title="Cliquer pour voir plus de détails">
                    <Avatar size="small" icon={<UserOutlined />} style={{ backgroundColor: PRIMARY_COLOR }} />
                    <Text>{text}</Text>
                </Tooltip>
            )
        },
        {
            title: 'Nom & Prénom',
            key: 'fullname',
            width: 300,
            render: (_, record) => <Tooltip onClick={() => navigate(`/details-utilisateur/${record.codeId}`)} title="Cliquer pour voir plus de détails">
                <Text strong>{record?.personne?.nom} {record?.personne?.prenom}</Text>
            </Tooltip>
        },
        {
            title: 'Profil',
            dataIndex: 'profil',
            key: 'profil',
            render: (profil) => (
                <Tag color={PRIMARY_COLOR} style={{ borderRadius: '12px' }}>{profil?.nom}</Tag>
            )
        },
        {
            title: "Agence",
            dataIndex: "agence",
            key: "agence",
            render: (_, record) => (
                <>
                    {record?.agence?.nom}
                </>
            )
        },
        {
            title: 'Statut',
            dataIndex: 'statut',
            key: 'statut',
            width: 10,
            render: (_, record) => (
                <Tag
                    icon={record?.active ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                    color={record?.active ? SUCCESS_COLOR : ERROR_COLOR}
                    style={{ borderRadius: '12px', fontWeight: 500 }}
                >
                    {record?.active ? 'Actif' : 'Inactif'}
                </Tag>
            )
        },
        // {
        //     title: 'Action',
        //     key: 'action',
        //     width: 10,
        //     render: (_, record) => (
        //         <Button
        //             type="primary"
        //             icon={<EyeOutlined />}
        //             style={{
        //                 backgroundColor: PRIMARY_COLOR,
        //                 borderColor: PRIMARY_COLOR,
        //                 borderRadius: '8px'
        //             }}
        //             onClick={() => navigate(`/details-utilisateur/${record.codeId}`)}
        //         >
        //             Voir
        //         </Button>
        //     )
        // }
    ];

    return (
        <div style={{ overflowX: 'auto' }}>
            <div style={{ marginBottom: '24px' }}>
                {canAddUser && <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    size="large"
                    style={{
                        borderRadius: '10px',
                        backgroundColor: PRIMARY_COLOR,
                        borderColor: PRIMARY_COLOR,
                        fontWeight: 500,
                        height: '44px'
                    }}
                    onClick={() => navigate(`/ajouter-utilisateur`)}
                >
                    Ajouter un utilisateur
                </Button>}
            </div>
            <Table
                columns={columns}
                dataSource={utilisateurs}
                pagination={{
                    pageSize: 5,
                    style: { marginTop: '24px' }
                }}
                style={{ borderRadius: '12px' }}
            />
        </div>
    )
}

export default UtilisateursAgenceTab
